export default "__VITE_ASSET__Da9k90I7__"